// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anpr-event__thumbnail[data-v-52361c3c]{position:relative}.anpr-event__thumbnail__loader[data-v-52361c3c],.anpr-event__thumbnail__play-btn[data-v-52361c3c]{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
